// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- DS Component */
:root {
    /* Background colors */
    --ds-tag-bg-color: var(--ds-color-grey-indigo-50);
    --ds-tag-bg-disabled-color: var(--ds-color-grey-indigo-70);
    /* Text colors */
    --ds-tag-text-color: var(--ds-color-grey-10);
    --ds-tag-text-disabled-color: var(--ds-color-grey-30);
    /* Outline colors */
    --ds-tag-outline-focus-color: var(--ds-color-focus-outline);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
